export default __webpack_public_path__ + "static/media/seguro.5406afe0.svg";